const styles = {
    wrapper: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        minHeight: 'calc(100vh - 120px)',
        padding: '20px',
        background: 'linear-gradient(to bottom, #f7fafc 0%, #edf2f7 100%)',
    },
    form: {
        background: '#fff',
        padding: '40px',
        borderRadius: '16px',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
        width: '100%',
        maxWidth: '450px',
        textAlign: 'center',
    },
    heading: {
        fontSize: '28px',
        fontWeight: '700',
        marginBottom: '30px',
        color: '#2d3748',
        letterSpacing: '-0.5px',
    },
    inputGroup: {
        marginBottom: '20px',
        textAlign: 'left',
        position: 'relative',
    },
    label: {
        display: 'block',
        marginBottom: '8px',
        fontSize: '14px',
        fontWeight: '600',
        color: '#4a5568',
    },
    input: {
        width: '100%',
        padding: '14px 16px',
        fontSize: '15px',
        borderRadius: '10px',
        border: '2px solid #e2e8f0',
        boxSizing: 'border-box',
        transition: 'all 0.3s ease',
        outline: 'none',
        fontFamily: 'inherit',
    },
    inputField: {
        width: '100%',
        padding: '14px 45px 14px 16px', // Added right padding for icon
        fontSize: '15px',
        borderRadius: '10px',
        border: '2px solid #e2e8f0',
        boxSizing: 'border-box',
        transition: 'all 0.3s ease',
        outline: 'none',
    },
    passwordToggleIcon: {
        position: 'absolute',
        right: '15px',
        top: '50%',
        transform: 'translateY(-50%)',
        cursor: 'pointer',
        color: '#a0aec0',
        zIndex: 10,
        background: 'none',
        border: 'none',
        padding: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    submitBtn: {
        width: '100%',
        padding: '14px',
        background: 'linear-gradient(135deg, #2563eb 0%, #1e40af 100%)',
        color: 'white',
        border: 'none',
        borderRadius: '10px',
        fontSize: '16px',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'transform 0.2s, box-shadow 0.2s',
        boxShadow: '0 4px 15px rgba(37, 99, 235, 0.3)',
    },
    homeBtn: {
        width: '100%',
        padding: '12px',
        backgroundColor: '#718096',
        color: 'white',
        border: 'none',
        borderRadius: '10px',
        fontSize: '15px',
        fontWeight: '500',
        cursor: 'pointer',
        marginTop: '12px',
        transition: 'background-color 0.3s',
    },
    logoutBtn: {
        width: '100%',
        padding: '12px',
        backgroundColor: '#f56565',
        color: 'white',
        border: 'none',
        borderRadius: '10px',
        fontSize: '15px',
        fontWeight: '500',
        cursor: 'pointer',
        marginTop: '20px',
        transition: 'background-color 0.3s',
    },
    errorMessage: {
        color: '#e53e3e',
        backgroundColor: '#fed7d7',
        fontSize: '14px',
        padding: '12px 16px',
        borderRadius: '8px',
        marginBottom: '16px',
        border: '1px solid #fc8181',
    },
    successMessage: {
        color: '#2f855a',
        backgroundColor: '#c6f6d5',
        fontSize: '14px',
        padding: '12px 16px',
        borderRadius: '8px',
        marginBottom: '16px',
        border: '1px solid #68d391',
    },
    link: {
        color: '#2563eb',
        textDecoration: 'none',
        fontWeight: '500',
        transition: 'color 0.2s',
    },
};

export default styles;
